export { CookiesConsentProvider } from './client/cookies.provider';
export { useCookiesConsent } from './client/cookies.hook';
export { hasConsent } from './server/has-consent';
import getCookiesConfiguration from './configuration';
export { getCookiesConfiguration };
export { type CookieOptions } from './cookie-options';
